var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnifier = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 111,
  viewBox: "0 0 111 111",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#3A3F99",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 53.419,
  cy: 53.419,
  r: 53.419,
  fill: "#06081D"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49.411,
  cy: 49.411,
  r: 23.862
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.282 66.282 81.29 81.29"
}))));
export { SvgMagnifier as ReactComponent };
export default __webpack_public_path__ + "assets/images/magnifier.svg";